import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../Constants/queryKeys';
import { GetCurrentStudyYear, GetStudyYears } from '../helper/apiHelper';

export const useCurrentStudyYear = () => {
  return useQuery({
    queryKey: [...QUERY_KEYS.CURRENT_STUDY_YEAR],
    queryFn: GetCurrentStudyYear,
  });
};

export const useStudyYears = () => {
  return useQuery({
    queryKey: [...QUERY_KEYS.STUDY_YEARS],
    queryFn: GetStudyYears,
  });
};
